import React, { useState } from "react";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
// import "./routing.css";
import { Avatar, Chip, IconButton, Tooltip, Typography } from "@mui/material";
import { useAuth } from "../../../context/API_Client";
import {
  compareDatesForSorting,
  convertIsoToGivenDateFormat,
  formatAmount,
  isEmpty,
  sortDateTime,
} from "../../utils/utils";
import MoreOptionsPopOver from "../../../reusableComponents/moreOptionsPopOver/MoreOptionsPopOver";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export function ReconFileSchema(
  configDetails,
  dropDownInfo,
  operationPermissions,
  invalidFileDownload,
  handleRevertFile,
  timeZone
) {
  const { isAuthorizedPermission } = useAuth();

  const handleActionSelect = (data) => {
    if (data?.type == "rollback") {
      if (data?.data?.fileName) {
        handleRevertFile(data?.data?.fileName);
      }
    }
  };
  const isRollbackAvailable = (data) => {
    if (
      data?.status?.toLowerCase() == "processing_failed" ||
      data?.status?.toLowerCase() == "processed" ||
      data?.status?.toLowerCase() == "reprocessed" ||
      data?.status?.toLowerCase() == "reverting_failed"
    ) {
      return true;
    }
    return false;
  };

  const HeaderWithInfo = ({ header, infoText }) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{header}</span>
        <div style={{ marginLeft: 5, cursor: "pointer" }}>
          <Tooltip
            id={`tooltip-${header}`}
            title={infoText || "Additional information"}
          >
            <IconButton
              sx={{
                "&:hover": { backgroundColor: "transparent" },
              }}
              disableFocusRipple
              disableTouchRipple
            >
              <InfoOutlinedIcon
                sx={{
                  // color: "#0B6A48",
                  width: "20px",
                  height: "20px",
                  order: 1,
                  marginLeft: "2px",
                }}
              />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  const statusColorList = {
    uploading: "#FBEFCB",
    uploading_failed: "#FDE3D6",
    uploaded: "#FBEFCB",
    transforming: "#FBEFCB",
    transforming_failed: "#FDE3D6",
    transformed: "#D5FBD2",
    processing: "#FBEFCB",
    processing_failed: "#FDE3D6",
    processed: "#D5FBD2",
    reverting: "#FBEFCB",
    reverting_failed: "#FDE3D6",
    reverted: "#D5FBD2",
  };

  const schema = {
    metadata: {
      title: "Recon Files",
      minHeight: 600,
      minWidth: 500,
      position: "relative",
      rowHeight: 100,
      showTitle: false,
      defaultSortInfo: { name: "updatedOn", dir: -1 },
      defaultVisible: [
        "fileName",
        // "addedOn",
        // "fileType",
        "source",
        "recordsTimestamp",
        "pspCode",
        // "invalidRecords",
        "Status",
        "actions",
        "reconValue",
        // "outputRecords",
        "processedRecords",
        // "fileRecords"

      ],
    },
    fields: [
      {
        name: "source",
        header: "Source",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        render: ({ data, ...rest }) => {

          return (
            <div
              style={{
                marginLeft: "-12px",
                maxWidth: ` ${rest?.cellProps?.computedWidth ? `${rest?.cellProps?.computedWidth}px` : " 180px"}`,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.source && (
                <HoverToDisplayFullTitle
                  title={data.source}
                  len={20}
                />
              )}
            </div>
          );
        },
      },
      {
        name: "recordsTimestamp",
        header: "Month",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 150,
        maxWidth: 160,
        textAlign: "center",
        sortable: false,
        render: ({ data }) => {
          return (
            <span style={{ marginLeft: "-12px" }}>{data?.recordsTimestamp}</span>
          );
        },
      },
      {
        name: "fileName",
        header: "File Name",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 200,
        sortable: false,
        textAlign: "center",
        render: ({ data, ...rest }) => (
          <div
            style={{
              marginLeft: "-12px",
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: '1 1 0%'
            }}
          >
            {data?.fileName && (
              <HoverToDisplayFullTitle title={data?.fileName} len={15} />
            )}
          </div>
        ),
      },
      {
        name: "updatedOn",
        header: "Updated At",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 230,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        sort: compareDatesForSorting,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.updatedOnConverted || ""}
            </span>
          );
        },
      },
      {
        name: "processedRecords",
        header: (
          <HeaderWithInfo
            header=" Total Processed Records"
            infoText="Total number of unique and un-merged records processed in the file. It will also include additional records processed to handle multi-matching reconciliations."
          />
        ),

        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 280,
        textAlign: "center",
        sortable: false,
        visible: true,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {formatAmount({ amount: data?.processedRecordCount ? Math.round(data?.processedRecordCount) : data?.processedRecordCount })}
          </div>
        ),
      },
      {
        name: "reconValue",
        header: (
          <HeaderWithInfo
            header="Total Recon Value"
            infoText="Total aggregated amount of the processed records present in the file."
          />
        ),

        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 230,
        maxWidth: 230,
        textAlign: "center",
        sortable: false,
        visible: true,

        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.totalReconValue ? formatAmount({ amount: Math.floor(data?.totalReconValue) }) : ""}
          </div>
        ),
      },
      {
        name: "Status",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 250,
        textAlign: "center",
        sortable: false,
        render: ({ data }) => {
          let backgroundColor = data?.status
            ? statusColorList[data?.status?.toLowerCase()] || "#E2E1FF"
            : "";

          return (
            <div
              style={{
                marginLeft: "-20px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                textTransform: "uppercase",
                display: "flex",
                alignItems: "center",
                lineHeight: "1.5"
              }}
            >
              <span>
                {data?.status || ""}
              </span>
              <span class="report-tooltip" style={{ display: "inline-flex" }}>
                {(data?.status?.toLowerCase()?.includes("failed") || data?.status?.toLowerCase()?.includes("reverted")) && <Tooltip
                  title={data?.statusReason || data?.status}
                >
                  <IconButton
                    sx={{
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                    disableFocusRipple
                    disableTouchRipple
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "#0B6A48",
                        width: "16px",
                        height: "16px",
                        order: 1,
                        marginLeft: "2px",
                      }}
                    />
                  </IconButton>
                </Tooltip>}
              </span>
            </div>
          );
        },
      },
      {
        name: "fileType",
        header: "File Type",
        visible: false,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        render: ({ data, ...rest }) => {

          return (
            <div
              style={{
                marginLeft: "-12px",
                maxWidth: ` ${rest?.cellProps?.computedWidth ? `${rest?.cellProps?.computedWidth}px` : " 180px"}`,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.fileType && (
                <HoverToDisplayFullTitle
                  title={data.fileType}
                  len={20}
                />
              )}
            </div>
          );
        },
      },
      {
        name: "uploadedBy",
        header: "Uploaded By",
        visible: false,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 250,
        textAlign: "center",
        sortable: false,
        render: ({ data, ...rest }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: ` ${rest?.cellProps?.computedWidth ? `${rest?.cellProps?.computedWidth}px` : " 250px"}`,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.uploadedBy && (
              <HoverToDisplayFullTitle title={data?.uploadedBy} len={20} />
            )}
          </div>
        ),
      },
      {
        name: "addedOn",
        header: "Uploaded At",
        visible: false,
        type: "string",
        filtering: false,
        minWidth: 230,
        defaultFlex: 1,
        textAlign: "start",
        sortable: true,
        sort: compareDatesForSorting,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.addedOnConverted || ""}
            </span>
          );
        },
      },
      {
        name: "fileRecords",
        header: "Total File Records",
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 220,
        textAlign: "center",
        sortable: false,
        visible: false,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.totalRecords ? formatAmount({ amount: Math.floor(data?.totalRecords) }) : ""}
          </div>
        ),
      },
      {
        name: "outputRecords",
        header: "Total Output Records",
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 250,
        textAlign: "center",
        sortable: false,
        visible: false,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.outputRecordCount ? formatAmount({ amount: Math.floor(data?.outputRecordCount) }) : formatAmount({ amount: Math.floor(data?.indexedRecordCount) }) || ""}
          </div>
        ),
      },
      {
        name: "invalidRecords",
        //         header: (
        //           <HeaderWithInfo
        //             header="Invalid Records"
        //             infoText="Unprocessed records due to duplicate, missing policy numbers.
        // "
        //           />
        //         ),
        header: "Invalid Records",
        visible: isAuthorizedPermission(
          operationPermissions?.downloadSkippedRecord
        ),
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        visible: false,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {!isEmpty(data?.ignoredRecordCount) && (
              <img
                src="/assets/downloadReport.svg"
                style={{
                  height: "28px",
                  width: "28px",
                  objectFit: "contain",
                  marginRight: "8px",
                  mixBlendMode: "multiply",
                  marginLeft: "20px",
                  cursor: "pointer",
                }}
                onClick={() => invalidFileDownload(data?.fileName)}
              />
            )}
          </div>
        ),
      },
      {
        name: "actions",
        header: "Actions",
        visible: isAuthorizedPermission(
          operationPermissions?.rollbackPermission
        ),
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 100,
        textAlign: "center",
        alignItems: "center",
        sortable: false,
        render: ({ data }) => {
          let items = [
            {
              id: "rollback",
              label: (
                <div style={{ display: "flex", gap: "4px" }}>
                  <Typography>Rollback</Typography>
                </div>
              ),
              value: {
                type: "rollback",
                data: data,
              },
              enable: isRollbackAvailable(data),
            },
          ];
          return (
            <MoreOptionsPopOver
              items={items}
              handleActionSelect={handleActionSelect}
            />
          );
        },
      },
    ],
  };

  return schema;
}
